// Como um caixa já fechado terminou — para a aba Caixas anteriores e o painel
// do fechamento (25/10/2026). Sem tela, sem rede.

import { diaLocal, tempoAberto } from "./caixa";

/** Conferência gravada no fechamento: lista [{forma, esperado, contado, diferenca, bateu, automatico}] ou null. */
export function conferenciaDoCaixa(caixa) {
  let lista = caixa?.conferencia_detalhe || caixa?.conferencia;
  if (typeof lista === "string") { try { lista = JSON.parse(lista); } catch (_) { lista = null; } }
  return Array.isArray(lista) ? lista : null;
}

/**
 * {tipo, valor, falta}: "bateu", "faltou", "sobrou" ou "sem" (fechado sem contagem).
 * "bateu" pode ter valor: a diferença que ficou dentro da diferença aceitável
 * da loja (Preferências → Caixa, 27/10/2026) — ex.: bateu, mas faltaram R$ 0,02.
 * Caixa fechado antes da v1.5.784 não tem resultado gravado: vale a diferença do total.
 * O servidor classifica igual para filtrar e contar (backend/api/v1/caixa/anteriores.py).
 */
export function resultadoDoCaixa(h) {
  const dif = h?.diferenca ?? ((h?.valor_fechamento_real || 0) - (h?.valor_fechamento_esperado || 0));
  if (h?.resultado_conferencia === "conferido" || (!h?.resultado_conferencia && Math.abs(dif) < 0.01)) {
    return { tipo: "bateu", valor: Math.abs(dif) >= 0.01 ? Math.abs(dif) : 0, falta: dif < 0 };
  }
  if (!h?.resultado_conferencia && h?.valor_fechamento_real == null) return { tipo: "sem", valor: 0 };
  return { tipo: dif < 0 ? "faltou" : "sobrou", valor: Math.abs(dif) };
}

/** "qua" do dia da abertura (no horário da loja). */
export function diaDaSemana(iso) {
  const [a, m, d] = diaLocal(iso).split("-").map(Number);
  if (!a) return "";
  return new Date(a, m - 1, d).toLocaleDateString("pt-BR", { weekday: "short" }).replace(".", "");
}

/** "quarta-feira, 22 de outubro de 2026". */
export function dataPorExtenso(iso) {
  const [a, m, d] = diaLocal(iso).split("-").map(Number);
  if (!a) return "";
  return new Date(a, m - 1, d).toLocaleDateString("pt-BR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
}

const CANAIS = { Cardapio: "Cardápio digital", Balcao: "Balcão", MesaQR: "Mesa (QR Code)" };
/** Nome do canal como o lojista conhece ("Balcao" → "Balcão"). */
export const nomeDoCanal = (modulo) => CANAIS[modulo] || modulo || "Outros";

/** "12h00" do abrir ao fechar. */
export const duracao = (h) => (h?.opened_at && h?.closed_at ? tempoAberto(h.opened_at, new Date(h.closed_at)) : "");

/** "Outubro de 2026" — os caixas da lista são agrupados pelo mês da abertura. */
export function mesDoCaixa(iso) {
  const [a, m] = diaLocal(iso).split("-").map(Number);
  if (!a) return "Sem data";
  const nome = new Date(a, m - 1, 1).toLocaleDateString("pt-BR", { month: "long", year: "numeric" });
  return nome.charAt(0).toUpperCase() + nome.slice(1);
}

/** [{mes, caixas}] na ordem da página (mais recente primeiro). */
export function porMes(lista) {
  const grupos = [];
  for (const h of lista || []) {
    const mes = mesDoCaixa(h.opened_at);
    let g = grupos[grupos.length - 1];
    if (!g || g.mes !== mes) { g = { mes, caixas: [] }; grupos.push(g); }
    g.caixas.push(h);
  }
  return grupos;
}
